import { RoundsSegmentGroupBase } from "../RoundsSegmentGroup";
import { TournamentSegmentBase } from "../TournamentSegment";

export type SwissSegment = TournamentSegmentBase<"Swiss", Swiss>;

export type Swiss = RoundsSegmentGroupBase & {};

export const canGroupSwissMatches = (swiss: Swiss) => {
  if (swiss.rounds.length === 0) {
    return true;
  }

  const numberOfMatchesInRoundOne = swiss.rounds[0].matchIds.length;
  // If not equal number of matches per round, assumes not Buchholtz and can group properly
  if (
    swiss.rounds.some((r) => r.matchIds.length !== numberOfMatchesInRoundOne)
  ) {
    return true;
  }

  var maxNumberOfRounds = 0;
  var numMatches = numberOfMatchesInRoundOne;
  while (numMatches % 2 === 0) {
    maxNumberOfRounds++;
    numMatches = numMatches / 2;
  }

  return swiss.rounds.length <= maxNumberOfRounds;
};
